import { HttpLoaderFactory } from './application/translation/httpLoaderFactory';
const ɵ0 = HttpLoaderFactory;
export class SharedModule {
}
export { ɵ0 };
